import context from './features/context';
import pageDetails from './features/pageDetails';
import state from './features/state';
import streams from './features/streams';
export default function () {
    // Safeguard only, no real use case yet - returning an instance of the object when running in a backend environment (SSR)
    if (typeof window === 'undefined')
        return initObject();
    window.__TELUS_ANALYTICS__ = window.__TELUS_ANALYTICS__ || initObject();
    return window.__TELUS_ANALYTICS__;
}
function initObject() {
    return {
        context: context(),
        pageDetails: pageDetails(),
        state: state(),
        streams: streams()
    };
}
